import { round as _round } from 'lodash';
import { ColorPaletteVariants } from '@origin-digital/ods-types/.';
import { STATE } from '@origin-digital/sales-common';

export const colorPaletteKeys = [
  'disabled',
  'disabledText',
  'error',
  'errorDark',
  'errorLight',
  'grey50',
  'grey100',
  'grey200',
  'grey300',
  'grey400',
  'grey500',
  'grey600',
  'primary',
  'primaryDark',
  'primaryLight',
  'primaryB',
  'primaryBDark',
  'primaryBLight',
  'secondaryB',
  'secondaryBDark',
  'secondaryBLight',
  'secondary',
  'secondaryDark',
  'secondaryLight',
  'success',
  'successDark',
  'successLight',
  'transparent',
  'warning',
  'warningDark',
  'warningLight',
  'white',
  'critical',
  'criticalLight',
  'criticalDark',
  'caution',
  'cautionLight',
  'cautionDark',
  'positive',
  'positiveLight',
  'positiveDark',
  'info',
  'infoLight',
  'infoDark',
  'neutral',
  'neutralLight',
  'neutralDark',
  'promote',
  'promoteLight',
  'promoteDark',
  'promoteB',
  'promoteBLight',
  'promoteBDark',
  'promoteC',
  'promoteCLight',
  'promoteCDark',
  'promoteD',
  'promoteDLight',
  'promoteDDark',
  'iconDark',
  'cardBackground',
  'cardBackgroundSecondary',
] as const satisfies ColorPaletteVariants[];

/*
 * Check if color string is a valid ods palette or css color.
 */
export function isValidCssColor(color: string): boolean {
  const brandColors: Set<string> = new Set(colorPaletteKeys);
  if (brandColors.has(color)) {
    return true;
  }

  const style = new Option().style;
  style.color = color;
  if (!style.color) return false;

  const rgbRegex = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(\.\d+)?|\.\d+))?\)$/;
  const match = color.match(rgbRegex);

  if (match) {
    const [r, g, b] = match.slice(1, 4).map(Number);
    return r <= 255 && g <= 255 && b <= 255;
  }

  return true;
}

export const ROUNDTO = 2;

export const round = (amount: string | number, roundTo: number): string => {
  const numericalAmount = Number(amount);
  const stringAmount = numericalAmount.toString();
  const rounded = _round(Number(stringAmount), roundTo).toFixed(roundTo);
  if (Number(rounded) < numericalAmount) {
    // 10000000.00000001 => '10000000.01',
    // 32.144 => '32.15',
    const conservativeNumber = Number(rounded) + Number(`10e-${roundTo + 1}`);
    return conservativeNumber.toFixed(roundTo);
  } else {
    return rounded;
  }
};

export const roundZero = (value: number | string): string => {
  const strValue = round(value, ROUNDTO);
  const decimalPart = strValue.split('.')[1];

  if (decimalPart === '00') {
    return parseInt(strValue).toFixed(0);
  }

  return strValue;
};

export const isNECFState = (state: STATE): boolean => {
  const necStates = ['NSW', 'ACT', 'QLD', 'SA', 'TAS'];
  return necStates.includes(state);
};
